// plugins/vuetify.js
import { createVuetify } from 'vuetify'
import 'vuetify/styles' // Global CSS has to be imported
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

export default defineNuxtPlugin(nuxtApp => {
  const vuetify = createVuetify({
    components,
    directives
})

  nuxtApp.vueApp.use(vuetify)
})



    // components: [
    //     'VSlideGroup', 'VSlideGroupItem', 'VIcon', 'VBtn', 'VRow', 'VCol', 'VImg',
    //     'VCard', 'VParallax', 'VHover', 'VSheet', 'VHover', 'VContainer', 'VLabel',
    //     'VFieldLabel', 'VField', 'VInput', 'VDivider', 'VTimeline', 'VTimelineItem',
    //     'VAlert', 'VApp', 'VAppBar', 'VAutocomplete', 'VAvatar', 'VBadge', 'VBanner',
    //     'VBottomNavigation', 'VBottomSheet', 'VBreadcrumbs', 'VBtnGroup', 'VBtnToggle',
    //     'VCarousel', 'VCheckbox', 'VChip', 'VChipGroup', 'VCode', 'VColorPicker',
    //     'VCombobox', 'VConfirmEdit', 'VCounter', 'VDataIterator', 'VDataTable', 'VDatePicker',
    //     'VDefaultsProvider', 'VDialog', 'VEmptyState', 'VExpansionPanel', 'VFab', 'VFileInput',
    //     'VProgressLinear', 'VRadio', 'VRadioGroup', 'VRangeSlider', 'VRating', 'VResponsive',
    //     'VSelect', 'VSelectionControl', 'VSelectionControlGroup', 'VSkeletonLoader', 'VSlider',
    //     'VLazy', 'VList', 'VLocaleProvider', 'VMain', 'VMenu', 'VMessages', 'VNavigationDrawer',
    //     'VSnackbar', 'VSparkline', 'VSpeedDial', 'VStepper', 'VSwitch', 'VSystemBar', 'VTable',
    //     'VTabs', 'VTextarea', 'VTextField',  'VToolbar', 'VTooltip',
    //     'VThemeProvider', 'VWindow', 'VValidation',
    //     'VFooter', 'VForm', 'VOverlay', 'VPagination', 'VLayout',
    //   ]
